import { IonButton, IonContent, IonHeader, IonPage, IonText, IonTitle, IonToolbar } from '@ionic/react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import './CadastroSucesso.css';

const CadastroSucesso: React.FC = () => {
  const history = useHistory();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>Acesso liberado</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <IonText className="text-content">
          <p>Seja bem-vindo.</p>
          <p>Seu acesso à plataforma Xeguei foi <b>liberado com sucesso</b>! Você já pode começar a utilizar todos os recursos disponíveis.</p>
          {/* <p>Como sugestão, assista aos vídeos da plataforma Xeguei:</p> */}
        </IonText>
        <div style={{
          background: '#f7f7f7',
          borderRadius: '8px',
          padding: '18px',
          marginBottom: '18px',
          textAlign: 'center',
          boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
        }}>
          <p style={{ marginBottom: 8 }}><strong>Treinamento Xeguei:</strong> Em apenas <strong>20 minutos</strong>, você aprende como aproveitar todas as funcionalidades do <strong>XEGUEI</strong>!</p>
          <a
            href="https://www.youtube.com/playlist?list=PLiEmugyBhYXWMGmMvzVttC9S37DZS76PK"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              color: '#fff',
              backgroundColor: '#4CAF50',
              padding: '10px 18px',
              textDecoration: 'none',
              borderRadius: '5px',
              fontWeight: 'bold',
              fontSize: '16px',
              marginTop: '8px',
              boxShadow: '0 2px 6px rgba(76,175,80,0.15)'
            }}
          >🎥 CLIQUE AQUI PARA ASSISTIR AO TREINAMENTO</a>
        </div>

        <IonText className="text-content">
          <p>Se precisar de ajuda ou tiver alguma dúvida, não hesite em entrar em contato conosco pelo WhatsApp
            <a target='_blank' href={"https://api.whatsapp.com/send?phone=5511963927646"} style={{ textDecoration: 'none', marginLeft: '4px' }}>
              (11) 96392-7646
            </a>.
          </p>
        </IonText>
        <div className="button-container" style={{ marginBottom: "18px" }}>
          <IonButton expand="block" onClick={() => {
            history.replace("/login");
          }}>Quero acessar minha conta</IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CadastroSucesso;
